import intermind from '../../../index';
import { AdminDashboard } from '../../../types';

export class AdminDashboardResource {
  async get(): Promise<AdminDashboard> {
    const { data } = await intermind.httpClient.get<AdminDashboard>('/admin/dashboard');
    return data;
  }
}
